import { Component, OnInit } from '@angular/core';
import { AuthenService } from '../../../../services/Authen/authen.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2'
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  constructor(
    private AuthenService: AuthenService,
    private router: Router,
    private SpinnerService: NgxSpinnerService
  ) { }

  auth_data: any;
  user_id: any
  user_data: any;
  username: any;
  password: any;
  fName: any;
  lName: any;
  eMail: any;
  tel: any;
  prefix: any;
  role: any;
  select_khet_data:any = [];
  select_khet_data_original:any = [];
  warning = false;
  center_data: any;
  select_center_data: any;

  institution_data: any;
  institution_khet_arr1 = [];
  institution_khet_arr2 = [];
  institution_province: any;

  ngOnInit(): void {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
    this.user_id = sessionStorage.getItem('id');
    this.get_one_user(this.user_id);
  }

  get_one_user(user_id) {
    this.AuthenService.GetUsersOne(user_id).subscribe(
      responce => {
        this.user_id = responce.id
        this.username = responce.username;
        this.password = responce.password;
        this.fName = responce.fname;
        this.lName = responce.lname;
        this.eMail = responce.email;
        this.tel = responce.tel;
        this.prefix = responce.titleName;
        this.role = responce.role;
        this.AuthenService.Get_mapping_user(responce.id).subscribe(
          responce2 => {
            if (responce2 != 0) {
              switch (responce2[0]['type']) {
                case 'province':
                  this.get_province();
                  this.institution_data = responce2[0]['idSeq'];
                  break;

                case 'khet':
                  for (let k = 0; k < responce2.length; k++) {
                    let data_push = responce2[k]['idSeq'] + " ";
                    if (data_push.length == 2) {
                      data_push = data_push + " ";
                    }
                    this.select_khet_data.push(data_push)
                  }
                  this.select_khet_data_original = this.select_khet_data;
                  this.get_khet();
                  break;

                case 'Central_agency':
                  this.get_center();
                  this.select_center_data = responce2[0]['idSeq'];
                  break;
              }
            }
          }
        );
      }
    );
  }

  update_user() {
    
    this.AuthenService.UpdateUsers(this.username, this.password, this.prefix, this.fName, this.lName, this.eMail, this.role, this.tel, this.auth_data['username'], this.user_id).subscribe(
      responce => {
        this.SpinnerService.show();
        if (this.role == 'District_inspector' || this.role == 'Provincial_officials' || this.role == 'Central_agency') {
          this.add_Dll(responce.id, this.role);
        }
        this.SpinnerService.hide();
        Swal.fire({
          icon: 'success',
          title: 'สร้างบัญชีใหม่เสร็จสิ้น',
          showConfirmButton: false,
          timer: 1500
        });
        this.router.navigate(['/user-management'])
      }
    );
  }

  get_role(data) {
    this.role = data;
    if (data == "Provincial_officials") {
      this.get_province();
      this.select_khet_data = [];
    } else if (data == "District_inspector") {
      this.get_khet();
      this.institution_province = [];
    } else if (data == "Central_agency") {
      this.get_center();
      this.select_khet_data = [];
      this.institution_province = [];
    }
  }

  get_khet() {
    this.AuthenService.Get_user_khet().subscribe(
      response => {
        if (this.select_khet_data != [] || this.select_khet_data != undefined) {
          for (let k = 0; k < response.length; k++) {
            const found = this.select_khet_data.find(element => element == response[k]['khetId']);
            if (found) {
              Object.assign(response[k], {
                "isCheck": true
              })
            } else {
              Object.assign(response[k], {
                "isCheck": false
              })
            }
          }
        }
        let i = 0;
        let j = 0;
        let data = [];
        data = response;
        let data2 = []
        while (i < response.length) {
          data[i]['khetId'] = data[i]['khetId'].trim();
          data2[i] = parseInt(data[i]['khetId']);
          i++;
        }
        //แบ่งฝั่งซ้ายขวาให้ modal เพื่อความสวยงาม และ เรียงข้อมูล
        while (j < 23) {
          const data_id = (element) => element == j + 1;
          const index = data2.findIndex(data_id)
          if (index != -1) {
            if (response[index]['khetId'] < 10) {
              response[index]['khetId'] = response[index]['khetId'] + "  ";
            } else {
              response[index]['khetId'] = response[index]['khetId'] + " ";
            }
            if (j < data.length / 2) {
              this.institution_khet_arr1.push(response[index]);
            } else {
              this.institution_khet_arr2.push(response[index]);
            }
          }
          j++;
        }
      }
    );
  }

  get_khet_select(value) {
    const found = this.select_khet_data.find(element => element == value);
    if (!found) {
      this.select_khet_data.push(value) //add
    } else {
      const index = this.select_khet_data.indexOf(value)
      this.select_khet_data.splice(index, 1);
    }
  }

  get_province() {
    this.AuthenService.Get_user_Province().subscribe(
      responce => {
        this.institution_province = responce;
      }
    );
  }

  get_center() {
    this.AuthenService.Get_user_center().subscribe(
      response => {
        this.center_data = response;
      }
    );
  }

  add_Dll(idUser, posRole) {"Provincial_officials"
    let body = [];
    if (posRole == 'District_inspector') {
      for (let i = 0; i < this.select_khet_data.length; i++) {
        const data = {
          "idUser": idUser,
          "type": "khet",
          "idSeq": this.select_khet_data[i]
        };
        body.push(data);
      }
    } else if (posRole == 'Provincial_officials') {
      const data = {
        "idUser": idUser,
        "type": "province",
        "idSeq": this.institution_data
      };
      body.push(data);
    } else if (posRole == 'Central_agency') {
      const data = {
        "idUser": idUser,
        "type": "center",
        "idSeq": this.select_center_data
      };
      body.push(data);
    }
    this.AuthenService.Add_mapping_user(body, idUser).subscribe(
      responce => {
        this.SpinnerService.hide();
      }
    );
  }

  cancle() {
    this.router.navigate(['/user-management']);
  }

}
